import { AdvertComponent } from 'components/advert/advert-component.js';
import { AdvertErrorBoundary } from 'components/advert/advert-error-boundary.js';
import { AdComponent } from 'redux-state/advertisement/types';

export const AdvertInterstitial = (
  props: AdComponent<{
    adDisplayTrueCB?: () => void;
  }>,
) => {
  return (
    <AdvertErrorBoundary>
      <AdvertComponent
        {...props}
        origin="interstitial"
      />
    </AdvertErrorBoundary>
  );
};
